var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("icorObjectEditSheetToolbar", {
        attrs: {
          tabitem: _vm.tabitem,
          sheetinfo: _vm.sheetinfo,
          menus: _vm.menus,
          wwwdescription: _vm.wwwdescription,
          imgsrc: _vm.imgsrc
        },
        on: { refresh: _vm.fetchData }
      }),
      _c(
        "q-scroll-area",
        { staticStyle: { width: "100%", height: "calc(100vh - 202px)" } },
        [
          _c("div", {
            staticClass: "row q-pt-xs q-pb-xs selectable",
            staticStyle: { "border-bottom": "1px dotted #bbb" }
          }),
          _vm._l(_vm.fields, function(field) {
            return !_vm.isFieldEmpty(field)
              ? _c(
                  "div",
                  {
                    key: field.Name,
                    staticClass: "row q-pt-xs q-pb-xs selectable",
                    staticStyle: { "border-bottom": "1px dotted #bbb" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-4 text-right q-pr-sm" },
                      [
                        _c("icorObjectEditSheetFieldName", {
                          attrs: { field: field }
                        })
                      ],
                      1
                    ),
                    field.IsMemo === 0 && field.IsTable === 0
                      ? _c(
                          "div",
                          {
                            staticClass: "col-8 q-pl-sm",
                            staticStyle: { "font-size": "0.8rem" }
                          },
                          [
                            field.FieldTypeID === 32
                              ? _c("div", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.Value) +
                                      "\n        "
                                  )
                                ])
                              : field.FieldTypeID === 64
                              ? _c("div", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(field.Value) +
                                      "\n        "
                                  )
                                ])
                              : field.FieldTypeID === 96
                              ? _c("div", [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.getTupleAsDateTimeStr(field.Value)
                                      ) +
                                      "\n        "
                                  )
                                ])
                              : field.FieldTypeID === 112
                              ? _c("div", [
                                  field.Value
                                    ? _c("span", [_vm._v("Tak")])
                                    : _c("span", [_vm._v("Nie")])
                                ])
                              : field.FieldTypeID === 144
                              ? _c("div", [
                                  field.IsMemo
                                    ? _c("div", [
                                        _c("pre", [
                                          _vm._v(
                                            "              " +
                                              _vm._s(field.Value) +
                                              "\n            "
                                          )
                                        ])
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(field.Value) +
                                            " "
                                        )
                                      ])
                                ])
                              : field.FieldTypeID > 255
                              ? _c("div", [
                                  field.FieldEditor === "ObjectsList"
                                    ? _c(
                                        "div",
                                        _vm._l(field.Value, function(value) {
                                          return _c(
                                            "q-btn",
                                            {
                                              key: value.ValueLink,
                                              staticClass:
                                                "text-no-transform q-ma-xs",
                                              attrs: {
                                                dense: "",
                                                color: "indigo-1",
                                                "text-color": "black",
                                                size: "sm"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.objectClick(value)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(value.Value))]
                                          )
                                        }),
                                        1
                                      )
                                    : field.WWWSingleValue === 1
                                    ? _c(
                                        "div",
                                        _vm._l(field.Value, function(value) {
                                          return _c(
                                            "q-btn",
                                            {
                                              key: value.ValueLink,
                                              staticClass:
                                                "text-no-transform q-ma-xs",
                                              attrs: {
                                                dense: "",
                                                color: "indigo-1",
                                                "text-color": "black",
                                                size: "sm"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.objectClick(value)
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(value.Value))]
                                          )
                                        }),
                                        1
                                      )
                                    : _c("div", [
                                        _vm._v(
                                          "\n            nieznane dane..\n          "
                                        )
                                      ])
                                ])
                              : _c("div", [
                                  _vm._v(
                                    "\n          nieznany typ [" +
                                      _vm._s(field.FieldTypeID) +
                                      "]: " +
                                      _vm._s(field.Value) +
                                      "\n        "
                                  )
                                ])
                          ]
                        )
                      : _vm._e(),
                    field.IsMemo === 1
                      ? _c("div", { staticClass: "col-12 q-pl-sm" }, [
                          field.FieldTypeID === 144
                            ? _c(
                                "div",
                                [
                                  field.Value !== ""
                                    ? _c("codemirror", {
                                        attrs: { options: _vm.cmOptions },
                                        model: {
                                          value: field.Value,
                                          callback: function($$v) {
                                            _vm.$set(field, "Value", $$v)
                                          },
                                          expression: "field.Value"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c("div", [
                                _vm._v(
                                  "\n          nieznany typ dla memo [" +
                                    _vm._s(field.FieldTypeID) +
                                    "]: " +
                                    _vm._s(field.Value) +
                                    "\n        "
                                )
                              ])
                        ])
                      : _vm._e(),
                    field.IsTable === 1
                      ? _c(
                          "div",
                          { staticClass: "col-12 q-pl-sm" },
                          [
                            field.Values.length > 0
                              ? _c("q-table", {
                                  attrs: {
                                    title: "",
                                    data: field.Values,
                                    columns: field.columns,
                                    "row-key": "_OID",
                                    pagination: field.pagination,
                                    filter: field.tableFilter,
                                    "rows-per-page-options": [
                                      5,
                                      10,
                                      20,
                                      25,
                                      50,
                                      100,
                                      0
                                    ],
                                    dense: "",
                                    separator: "cell",
                                    "no-data-label": "brak danych",
                                    "no-results-label": "brak wyników",
                                    "loading-label": "ładuję dane...",
                                    "rows-per-page-label": "rekordów na stronę",
                                    "selected-rows-label": function(
                                      rowsNumber
                                    ) {
                                      return (
                                        "zaznaczono " + rowsNumber + " pozycji"
                                      )
                                    },
                                    "pagination-label": function(
                                      start,
                                      end,
                                      total
                                    ) {
                                      return start + "-" + end + " z " + total
                                    },
                                    "filter-method": function(
                                      rows,
                                      terms,
                                      cols,
                                      cellValue
                                    ) {
                                      return _vm.tableFilter(
                                        field,
                                        rows,
                                        terms,
                                        cols,
                                        cellValue
                                      )
                                    }
                                  },
                                  on: {
                                    "update:pagination": function($event) {
                                      return _vm.$set(
                                        field,
                                        "pagination",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "top-right",
                                        fn: function(props) {
                                          return [
                                            field.Groups.length > 0
                                              ? _c("q-select", {
                                                  staticClass: "col-5 q-pl-sm",
                                                  staticStyle: {
                                                    "max-width": "70%"
                                                  },
                                                  attrs: {
                                                    options: field.Groups,
                                                    multiple: "",
                                                    toggle: "",
                                                    chips: "",
                                                    separator: "",
                                                    clearable:
                                                      field.GroupSel.length > 1,
                                                    filter: "",
                                                    "filter-placeholder":
                                                      "filtruj...",
                                                    prefix: "grupuj w/g: "
                                                  },
                                                  on: {
                                                    input: function(val) {
                                                      return _vm.selectChange(
                                                        field,
                                                        val
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: field.GroupSel,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        field,
                                                        "GroupSel",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "field.GroupSel"
                                                  }
                                                })
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              { staticClass: "col-1 q-pl-sm" },
                                              [_vm._v(" ")]
                                            ),
                                            _c("q-search", {
                                              staticClass: "col-5 q-pl-sm",
                                              attrs: {
                                                color: "secondary",
                                                placeholder: "szukaj..",
                                                clearable: ""
                                              },
                                              model: {
                                                value: field.tableFilter,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    field,
                                                    "tableFilter",
                                                    $$v
                                                  )
                                                },
                                                expression: "field.tableFilter"
                                              }
                                            })
                                          ]
                                        }
                                      },
                                      {
                                        key: "header",
                                        fn: function(props) {
                                          return _c(
                                            "q-tr",
                                            { attrs: { props: props } },
                                            _vm._l(props.cols, function(col) {
                                              return _c(
                                                "q-th",
                                                {
                                                  key: col.name,
                                                  staticClass:
                                                    "q-title bg-indigo-1 text-weight-bold",
                                                  staticStyle: {
                                                    "white-space": "normal"
                                                  },
                                                  attrs: { props: props }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n              " +
                                                      _vm._s(col.label) +
                                                      "\n            "
                                                  )
                                                ]
                                              )
                                            }),
                                            1
                                          )
                                        }
                                      },
                                      {
                                        key: "body",
                                        fn: function(props) {
                                          return _c(
                                            "q-tr",
                                            {
                                              staticClass: "cursor-pointer",
                                              attrs: { props: props },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.rowClick(props)
                                                }
                                              }
                                            },
                                            _vm._l(props.cols, function(col) {
                                              return _c(
                                                "q-td",
                                                {
                                                  key: col.name,
                                                  attrs: { props: props }
                                                },
                                                [
                                                  col.name === "Grupa"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          col.value !== ""
                                                            ? _c(
                                                                "q-chip",
                                                                {
                                                                  attrs: {
                                                                    dense: "",
                                                                    color:
                                                                      "positive"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      col.value
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    : col.value.constructor !==
                                                      Array
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size":
                                                              "0.8rem"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(col.value)
                                                          )
                                                        ]
                                                      )
                                                    : _vm._l(
                                                        col.value,
                                                        function(value) {
                                                          return _c(
                                                            "q-btn",
                                                            {
                                                              key: value._OID,
                                                              staticClass:
                                                                "text-no-transform q-ma-xs",
                                                              attrs: {
                                                                dense: "",
                                                                outline: "",
                                                                color: "black",
                                                                size: "sm"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.objectClick(
                                                                    value
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  value.Value
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                ],
                                                2
                                              )
                                            }),
                                            1
                                          )
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }